module.exports = __webpack_public_path__ + "img/step2_2.54b27d5a.jpg";